import { ISprintWords, wordsResponse } from '../../../textbook/types';

export enum SprintActionTypes {
  FETCH_SPRINT_WORDS = 'FETCH_SPRINT_WORDS',
  UPDATE_GROUP = 'UPDATE_GROUP',
  UPDATE_USERGROUP = 'UPDATE_USERGROUP',
  REMOVE_WORDS = 'REMOVE_WORDS',
  UPDATE_WORDS_SPRINT = 'UPDATE_WORDS_SPRINT',
}
interface fetchBookActionSuccess {
  type: SprintActionTypes.FETCH_SPRINT_WORDS;
  payload: ISprintWords[];
}

interface updateGroup {
  type: SprintActionTypes.UPDATE_GROUP;
  payload: number;
}
interface updateUsersGroup {
  type: SprintActionTypes.UPDATE_USERGROUP;
  payload: number;
}
interface removeWords {
  type: SprintActionTypes.REMOVE_WORDS;
}
interface updateWords {
  type: SprintActionTypes.UPDATE_WORDS_SPRINT;
  payload: ISprintWords[];
}
export type SprintAction =
  | fetchBookActionSuccess
  | updateGroup
  | updateWords
  | removeWords
  | updateUsersGroup;
